export default {
  from: 'De',
  to: 'A',
  enterNameOrNumber: 'Introducir número o nombre...',
  typeMessage: 'Escribir mensaje...',
  send: 'Enviar',
};
